import React, { useEffect, useState, useReducer, useContext, useRef } from "react";
import axios from "axios";
import { useForm } from 'react-hook-form';
import { DateRangeInput } from "@datepicker-react/styled";
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { IconRefresh } from "../../../svg";
import { CardPericiaOptions } from "../../../components/CardPericiaOptions";
import { DynamicRadio } from "../../../components/DynamicRadio";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { ToggleSwitch } from "../../../components/ToggleSwitch";
import { DynamicInput } from "../../../components/DynamicInput";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { PaginationCustom } from "../../../components/PaginationCustom";
import { ButtonOutline } from "../../../components/ButtonOutline";
import { Footer } from "../../../components/Footer";
import { StyledRow } from "../../../styled-components/StyledRow.style";
import { StyledColumn } from "../../../styled-components/StyledColumn.style";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import api from '../../../services/api';
import { DynamicCheckbox } from '../../../components/DynamicCheckbox';
import { Multiselect } from 'multiselect-react-dropdown';
import { MobileContext } from "../../../contexts/MobileContext";
import { getSinisterStatus, getSinisterPort, getSinisterTypes } from '../../../services/sinistro';
import { getClients } from '../../../services/clientes';
import { getCorretoras } from '../../../services/corretoras';
import { getReguladoras } from '../../../services/reguladoras';
import { getDisciplinas } from '../../../services/disciplinas';
import { getLideres } from '../../../services/lideres';

const initialState = {
    startDate: null,
    endDate: null,
    focusedInput: null,
};

const typeOptions = [
    { value: "civil", name: "tipo", label: "Civil" },
    { value: "eletrica", name: "tipo", label: "Elétrica" },
    { value: "mecanica", name: "tipo", label: "Mecânica" },
];

const advanceSearch = { name: 'advanceSeach', label: 'Pesquisa Avançada' };

function reducer(state, action) {
    switch (action.type) {
        case "focusChange":
            return { ...state, focusedInput: action.payload };
        case "dateChange":
            return action.payload;
        default:
            throw new Error();
    }
}

const defaultTypeOptions = [
    {
        "idDisciplina": 1,
        "titulo": "Civil"
    },
    {
        "idDisciplina": 2,
        "titulo": "Elétrica"
    },
    {
        "idDisciplina": 3,
        "titulo": "Mecânica"
    }
];

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

const fillTypeOptions = (typeOptions) => {
    const options = [];
    typeOptions.forEach(option => options.push({ value: option.idDisciplina, name: 'tipo', label: option.titulo }));
    return options;
}

const getListaPericias = async (formValues = null, currentPage, pageSize) => {

    let list = null;

    let params = `Start=${currentPage}&Length=${pageSize}`;

    if (formValues.data != null) {
        if (formValues.search.length > 0) {
            params += `&Search=${formValues.search}`;
        }
        if (formValues.data.PericiaSigla.length > 0) {
            params += `&PericiaSigla=${formValues.data.PericiaSigla}`;
        }
        if (formValues.idLider > 0) {
            params += `&PericiaLider=${formValues.idLider}`;
        }

        if (formValues.data.Segurado.length > 0) {
            params += `&Segurado=${formValues.data.Segurado}`;
        }

        if (formValues.data.Contato.length > 0) {
            params += `&Contato=${formValues.data.Contato}`;
        }

        if (formValues.data.Endereco.length > 0) {
            params += `&Endereco=${formValues.data.Endereco}`;
        }

        if (formValues.data.NumeroSinistro.length > 0) {
            params += `&NumeroSinistro=${formValues.data.NumeroSinistro}`;
        }

        if (formValues.data.NumeroApolice.length > 0) {
            params += `&NumeroApolice=${formValues.data.NumeroApolice}`;
        }

        if (formValues.idDisciplinas > 0) {
            params += `&Disciplinas=${formValues.idDisciplinas}`;
        }

        if (formValues.idCliente > 0) {
            params += `&IdCliente=${formValues.idCliente}`;
        }

        if (formValues.idReguladora > 0) {
            params += `&IdReguladora=${formValues.idReguladora}`;
        }

        if (formValues.idCorretora > 0) {
            params += `&IdCorretora=${formValues.idCorretora}`;
        }

        if (formValues.idTipoSinistro > 0) {
            params += `&IdTipoSinistro=${formValues.idTipoSinistro}`;
        }

        if (formValues.idPorteSinistro > 0) {
            params += `&IdPorteSinistro=${formValues.idPorteSinistro}`;
        }

        if (formValues.idStatus > 0) {
            params += `&Status=${formValues.idStatus}`;
        }

        if (formValues.startDate.length > 0) {
            params += `&PeriodoInicial=${formValues.startDate}`;
        }

        if (formValues.endDate.length > 0) {
            params += `&PeriodoFinal=${formValues.endDate}`;
        }
    }

    try {
        const response = await api.get(`Pericia/list?${params}`);
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}

export const Pericias = () => {
    const [showAdvanceSearch, setAdvanceSearch] = useState(false);
    const { register, handleSubmit, reset } = useForm();
    const [state, dispatch] = useReducer(reducer, initialState);
    const [typeOptions, setTypeOptions] = useState(fillTypeOptions(defaultTypeOptions));
    const [periciasData, setPericiasData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [disciplinaList, setDisciplinaList] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [reguladoraList, setReguladoraList] = useState([]);
    const [corretoraList, setCorretoraList] = useState([]);
    const [liderList, setLiderList] = useState([]);
    const [sinisterPort, setSinisterPort] = useState([]);
    const [sinisterStatus, setSinisterStatus] = useState([]);
    const [sinisterType, setSinisterType] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    var [tipoSinistro, setTipoSinistro] = useState(null);
    var [porteSinistro, setPorteSinistro] = useState(null);
    var [idTipoSinistro, setIdTipoSinistro] = useState(null);
    var [idPorteSinistro, setIdPorteSinistro] = useState(null);
    var [status, setstatus] = useState(null);
    var [idStatus, setIdStatus] = useState(null);
    var [disciplina, setDisciplina] = useState(null);
    var [idDisciplinas, setDisciplinasId] = useState([]);
    var [cliente, setCliente] = useState(null);
    var [idCliente, setIdCliente] = useState(null);
    var [corretora, setCorretora] = useState(null);
    var [idCorretora, setIdCorretora] = useState(null);
    var [lider, setLider] = useState(null);
    var [idLider, setLiderId] = useState(null);
    var [reguladora, setReguladora] = useState(null);
    var [idReguladora, setIdReguladora] = useState(null);
    var [searchReadOnly, setSearchReadOnly] = useState(false);
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const multiselectRef = useRef();

    const formSubmit = async (data) => {
        formData(data, 1, 10);
    }

    const formData = async (data, currentPage, pageSize) => {
        let formValues = {
            data: data,
            search: 0,
            idLider: idLider,
            idDisciplinas: idDisciplinas,
            idCliente: idCliente,
            idReguladora: idReguladora,
            idCorretora: idCorretora,
            idTipoSinistro: idTipoSinistro,
            idPorteSinistro: idPorteSinistro,
            idStatus: idStatus,
            startDate: new Date(state.startDate),
            endDate: new Date(state.endDate)
        };

        setPageSize(pageSize);

        const pericias = await getListaPericias(formValues, currentPage, pageSize);
        if (pericias.data.itens.length > 0) {
            setPericiasData(pericias);
            pageSize = pericias.data.itens.length;
        }
    };

    const getStatusToggle = (status) => {
        setAdvanceSearch(status);
        setSearchReadOnly(status);
        searchReadOnly = status;
    };

    const getTipoSinistro = (currentValue, value) => {
        var tipoSinistroResult = sinisterType.filter(function (o) {
            return o.idTipoSinistro == value;
        });

        tipoSinistro = tipoSinistroResult[0].nome;
        idTipoSinistro = tipoSinistroResult[0].idTipoSinistro;
        setTipoSinistro(tipoSinistro);
        setIdTipoSinistro(idTipoSinistro);
    };

    const getPorteSinistro = (currentValue, value) => {
        var porteSinistroResult = sinisterPort.filter(function (o) {
            return o.key == value;
        });

        porteSinistro = porteSinistroResult[0].value;
        idPorteSinistro = porteSinistroResult[0].key;
        setPorteSinistro(porteSinistro);
        setIdPorteSinistro(idPorteSinistro);
    };

    const getstatus = (currentValue, value) => {
        var statusResult = sinisterStatus.filter(function (o) {
            return o.key == value;
        });

        status = statusResult[0].value;
        idStatus = statusResult[0].key;
        setstatus(status);
        setIdStatus(idStatus);
    };

    const onGetDisciplina = (currentValue, value) => {
        let disciplinasList = [];

        disciplina = value.titulo;
        setDisciplina(disciplina);

        currentValue.map(a => { disciplinasList.push(a.idDisciplina) });
        idDisciplinas = disciplinasList;

        setDisciplinasId(disciplinasList);
    };


    const getSearch = async (currentValue, value, pageSize) => {

        let data = {
            PericiaSigla: null,
            Segurado: null,
            Contato: null,
            Endereco: null,
            NumeroSinistro: null,
            NumeroApolice: null
        }

        if (currentValue.length >= 3) {
            let formValues = {
                data: data,
                search: currentValue,
                idDisciplinas: null,
                idLider: null,
                idCliente: null,
                idReguladora: null,
                idCorretora: null,
                idTipoSinistro: null,
                idPorteSinistro: null,
                idStatus: idStatus,
                startDate: null,
                endDate: null
            };

            setPageSize(pageSize);

            const pericias = await getListaPericias(formValues, currentPage, pageSize);
            if (pericias.data.itens.length > 0) {
                setPericiasData(pericias);
                pageSize = pericias.data.itens.length;
            }
        }
    };

    const onRemoveDisciplina = (currentValue, value) => {
    }

    const getCliente = (currentValue, value) => {
        var clienteResult = clientList.filter(function (o) {
            return o.idCliente == value;
        });
        cliente = clienteResult[0].cliente;
        idCliente = clienteResult[0].idCliente;
        setCliente(cliente);
        setIdCliente(idCliente);
    };

    const getCorretora = (currentValue, value) => {
        var corretoraResult = corretoraList.filter(function (o) {
            return o.idCorretora == value;
        });
        corretora = corretoraResult[0].corretora;
        idCorretora = corretoraResult[0].idCorretora;
        setCorretora(corretora);
        setIdCorretora(idCorretora);
    };

    const getLider = (currentValue, value) => {
        var liderResult = liderList.filter(function (o) {
            return o.idUsuario == value;
        });
        lider = liderResult[0].nome;
        idLider = liderResult[0].idUsuario;
        setLider(lider);
        setLiderId(idLider);
    };

    const getReguladora = (currentValue, value) => {
        var reguladoraResult = reguladoraList.filter(function (o) {
            return o.idReguladora == value;
        });
        reguladora = reguladoraResult[0].reguladora;
        idReguladora = reguladoraResult[0].idReguladora;
        setReguladora(reguladora);
        setIdReguladora(idReguladora);
    };

    useEffect(() => {
        const asyncFn = async () => {
            const disciplinas = await getDisciplinas();
            if (!!disciplinas) {
                setDisciplinaList(disciplinas);
            }

            const clients = await getClients();
            if (!!clients) {
                setClientList(clients);
            }

            const reguladoras = await getReguladoras();
            if (!!reguladoras) {
                setReguladoraList(reguladoras)
            }

            const corretoras = await getCorretoras();
            if (!!corretoras) {
                setCorretoraList(corretoras)
            }

            const lideres = await getLideres();
            if (!!lideres) {
                setLiderList(lideres)
            }

            const sinisterPorts = await getSinisterPort(21);
            if (!!sinisterPorts) {
                setSinisterPort(sinisterPorts)
            }

            const sinisterTypes = await getSinisterTypes(20);
            if (!!sinisterTypes) {
                setSinisterType(sinisterTypes)
            }

            const sinisterStatus = await getSinisterStatus(4);
            if (!!sinisterStatus) {
                setSinisterStatus(sinisterStatus)
            }

            formData(null, 1, 10);
        }
        asyncFn()
    }, []);

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h2>Perícias</h2>
                            <IconRefresh color={"#EE4B21"} />
                        </div>
                        <ButtonOutline
                            outlineColor={"#EE4B21"}
                            backgroundColor={"#EE4B21"}
                            color={"#FFF"}
                            text={"Nova Perícia"}
                            maxWidth={"280px"}
                        />
                    </div>

                    <div className="card">

                        <StyledForm onSubmit={handleSubmit(formSubmit)}>

                            <div className="form-wrapper filter-container">

                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} componentReadOnly={searchReadOnly} placeholder={''} label={'Pesquisar'} name={'Search'} paramMethod={getSearch} />
                                </div>

                                <div className="form-container d-flex flex-column justify-content-center">
                                    <ToggleSwitch config={advanceSearch} setStatus={(status) => getStatusToggle(status)} />
                                </div>

                            </div>

                            <div className={!!showAdvanceSearch ? `form-wrapper filter-container` : `form-wrapper filter-container filter-hide`}>

                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Sigla perícia'} name={'PericiaSigla'} register={register} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicSelect placeholder={''} valuetext={lider} label={'Selecione o Lider'} name={'IdUsuario'} options={liderList} keyValue={'idUsuario'} keyLabel={'nome'} paramMethod={getLider} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Segurado'} name={'Segurado'} register={register} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Contato'} name={'Contato'} register={register} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Endereço'} name={'Endereco'} register={register} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Número do sinistro'} name={'NumeroSinistro'} register={register} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Número da apólice'} name={'NumeroApolice'} register={register} />
                                </div>

                                {/* <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                        <DynamicSelect  placeholder={''} valuetext={disciplina} label={'Selecione a disciplina'} name={'IdDisciplina'} options={disciplinaList} keyValue={'idDisciplina'} keyLabel={'titulo'}  paramMethod={getDisciplina} />
                                </div> */}

                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <Multiselect
                                        placeholder={'Selecione a disciplina'}
                                        showCheckbox="true"
                                        options={disciplinaList} // Options to display in the dropdown
                                        selectedValues={disciplinaList.selectedValue} // Preselected value to persist in dropdown
                                        onSelect={onGetDisciplina} // Function will trigger on select event
                                        onRemove={onRemoveDisciplina} // Function will trigger on remove event
                                        displayValue="titulo" // Property name to display in the dropdown options
                                        ref={multiselectRef}
                                    />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-9 col-lg-9 p-2">
                                    <DynamicSelect placeholder={''} valuetext={cliente} label={'Selecione o cliente'} name={'IdCliente'} options={clientList} keyValue={'idCliente'} keyLabel={'cliente'} paramMethod={getCliente} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicSelect placeholder={''} valuetext={reguladora} label={'Reguladora'} name={'IdReguladora'} options={reguladoraList} keyValue={'idReguladora'} keyLabel={'reguladora'} paramMethod={getReguladora} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicSelect placeholder={''} valuetext={corretora} label={'Corretora'} name={'IdCorretora'} options={corretoraList} keyValue={'idCorretora'} keyLabel={'corretora'} paramMethod={getCorretora} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4 p-2">
                                    <DynamicSelect placeholder={''} valuetext={tipoSinistro} label={'Tipo do Sinistro'} name={'IdTipoSinistro'} options={sinisterType} keyValue={'idTipoSinistro'} keyLabel={'nome'} paramMethod={getTipoSinistro} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4 p-2">
                                    <DynamicSelect placeholder={''} valuetext={porteSinistro} label={'Porte Sinistro'} name={'IdPorteSinistro'} options={sinisterPort} keyValue={'key'} keyLabel={'value'} paramMethod={getPorteSinistro} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4 p-2">
                                    <DynamicSelect placeholder={''} valuetext={status} label={'Status'} name={'IdStatusSinistro'} options={sinisterStatus} keyValue={'key'} keyLabel={'value'} paramMethod={getstatus} />
                                </div>

                                <div className="position-relative form-group col-6 p-2">
                                    <DateRangeInput
                                        vertical="false"
                                        onDatesChange={data => dispatch({ type: 'dateChange', payload: data })}
                                        onFocusChange={focusedInput => dispatch({ type: 'focusChange', payload: focusedInput })}
                                        startDate={state.startDate} // Date or null
                                        endDate={state.endDate} // Date or null
                                        focusedInput={state.focusedInput} // START_DATE, END_DATE or null
                                    />
                                </div>

                                <div className="position-relative form-group col-sm-3 col-md-3 col-lg-3 p-2">
                                    <input className='default-button' value='Limpar' type="button" onClick={() => {
                                        reset({
                                            PericiaSigla: '',
                                            Segurado: null,
                                            Contato: null,
                                            Endereco: null,
                                            NumeroSinistro: null,
                                            NumeroApolice: null
                                        });
                                        setLider(['Selecione o lider']);
                                        setDisciplina(['Selecione a disciplina']);
                                        setCliente(['Selecione o cliente']);
                                        setReguladora(['Reguladora']);
                                        setCorretora(['Corretora']);
                                        setTipoSinistro(['Tipo Sinistro']);
                                        setPorteSinistro(['Porte Sinistro']);
                                        setstatus(['Status']);
                                        multiselectRef.current.resetSelectedValues();
                                    }} />
                                </div>

                                <div className="position-relative form-group col-sm-3 col-md-3 col-lg-3 p-2">
                                    <ButtonOutline
                                        type={"submit"}
                                        outlineColor={"#EE4B21"}
                                        backgroundColor={"white"}
                                        color={"#EE4B21"}
                                        text={"Pesquisar"}
                                    />
                                </div>
                            </div>
                        </StyledForm>
                        <StldRow>
                            {periciasData != null ? periciasData.data.itens.map((item, index) => {
                                return (
                                    <StldColumn key={index} xs="12" sm="6" md="3">
                                        <CardPericiaOptions id={item.idSolicitacao} title={item.cliente.clienteNome} subtitle={item.local.local} info={item.tipoSinistro} type={item.disciplinas} />
                                    </StldColumn>
                                );
                            }) : null}
                        </StldRow>
                        {(() => {
                            if (periciasData != null) {
                                return (
                                    <PaginationCustom isMobile={isMobile}
                                        isDesktop={isDesktop}
                                        length={periciasData.data.page.length}
                                        recordsTotal={periciasData.data.page.recordsTotal}
                                        currentPage={currentPage}
                                        formData={formData}
                                        pageSize={pageSize}
                                        setPageSize={setPageSize}
                                        setPage={(page) => setCurrentPage(page)} />
                                )
                            }
                            return null
                        })()}
                    </div>
                    <br />
                </StyledDefaultPage>
            </main>

        </section>
    );
};

export const PericiasPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <Pericias />

                </>
            )}
        </>
    );
};
